module.exports = "/_next/static/images/saurabh-2924c59cacb1d62803b3a383c335e763.png";